import React from 'react';
import Slider from 'react-slick';

const images = ['/images/9.jpg', '/images/4.jpg', '/images/3.jpg', '/images/1.jpg', '/images/5.jpg', '/images/7.jpg', '/images/8.jpg'];

const ArrowButton = ({ onClick, direction }) => {
  const isNext = direction === 'next';
  const label = isNext ? 'Next hero image' : 'Previous hero image';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={`hidden md:inline-flex absolute top-1/2 z-20 h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-white/60 bg-[#0f2234cc] text-white transition-all duration-300 hover:scale-105 hover:bg-brand-accent hover:text-brand-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-accent ${
        isNext ? 'right-6' : 'left-6'
      }`}
    >
      <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d={isNext ? 'M9 6l6 6-6 6' : 'M15 6l-6 6 6 6'}
        />
      </svg>
    </button>
  );
};

const NextArrow = ({ onClick }) => <ArrowButton onClick={onClick} direction="next" />;
const PrevArrow = ({ onClick }) => <ArrowButton onClick={onClick} direction="prev" />;

const settings = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 750,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  accessibility: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />
};

const HeroMediaCarousel = () => {
  return (
    <div className="hero-carousel h-[70vh] md:h-[78vh]">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={image} className="h-[70vh] md:h-[78vh]">
            <img
              src={image}
              alt={`Holiday Motel exterior and room view ${index + 1}`}
              className="h-full w-full object-cover"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroMediaCarousel;
